import Modal from "../modal.component";
import NewShipmentForm from "../../forms/shipments/new.shipment.form";

const CreateShipmentModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="flex justify-evenly h-full w-full flex-row gap-6">
        <NewShipmentForm />
      </div>
    </Modal>
  );
};

export default CreateShipmentModal;
